import Person from "./person/component";
import image_eduard from "./eduard.jpg";
import image_george from "./george.jpg";
import image_steffi from "./steffi.jpg";

const Persons = () => {
  return (
    <div className="container">
      <Person
        name="Eduard S."
        image={image_eduard}
        responsibilities={[
          "gibt den Ton an",
          "Gesang, Keyboard, Akkordeon",
          'Management ("Orchester Chef")',
        ]}
        hobbies={["Musik machen", "Mit dem Flugsimulator in die Ferne reisen"]}
      />
      <Person
        name="George S."
        image={image_george}
        responsibilities={["sorgt für den Rythmus", "Gesang, Drums"]}
        hobbies={["Musik machen", "Frühaufsteher - wenn 12 Uhr als früh gilt"]}
      />
      <Person
        name="Steffi F."
        image={image_steffi}
        responsibilities={["Gesang", "unsere Frau für alle Fälle"]}
        hobbies={['Sorgt mit rollendem "R" für fränkischen Flair']}
      />
    </div>
  );
};

export default Persons;
